export default [
{
    key: "index",
    label: "ลำดับ",
    sortable: true
},
{
    key: "bank_account_name",
    label: "ชื่อลูกค้า",
    sortable: true
},
{
    key: "bank_account_id",
    label: "ข้อมูลธนาคาร",
    sortable: true
},
{
    key: "cod_amount",
    label: "ยอดเก็บ COD (บาท)",
    sortable: true,
    class: "text-right"
},
{
    key: "cod_fee",
    label: "ค่าบริการ (บาท)",
    sortable: true,
    class: "text-right"
},
{
    key: "cod_vat",
    label: "VAT (บาท)",
    sortable: true,
    class: "text-right"
},
{
    key: "return_cod",
    label: "ยอดคืน COD (บาท)",
    sortable: true,
    class: "text-right"
},
{
    key: "state",
    label: "สถานะ",
    sortable: true
},
{
    key: "created_at",
    label: "วันที่โอนคืน",
    sortable: true
},
{
    key: "actions",
    label: "การจัดการ",
    sortable: true
}
]